function toggleClickbox(e) {
 if (window.getComputedStyle(e.querySelector(".clickyboxes")).display === "none") {
    e.querySelector(".clickyboxes").style.display = 'block';
    e.querySelector(".variant-label").style.borderBottom = '1px solid #f9f8f5';
    e.querySelector(".ProductBundleSwatchSelector__action-icon").style.transform ='rotateX(180deg)';
  } else {
      e.querySelector(".clickyboxes").style.display = 'none';
      e.querySelector(".variant-label").style.removeProperty('border-bottom');
      e.querySelector(".ProductBundleSwatchSelector__action-icon").style.removeProperty('transform');
  }
  }       